// InvoicePhase Component
import { DropTarget as dropTarget } from 'react-dnd'

import InvoicePhaseBase from './invoice_phasebase.jsx'

const phaseTarget = {
  drop (props, monitor) {
    const item = monitor.getItem()

    if (props.phase && props.phase.groups.length > 0 && props.onDropItem) {
      if (item.type !== 'pagebreak' || props.phase.groups[0].items.length > 1) {
        if (props.phase.id !== item.phaseId) {
          props.onMoveItem(
            item.phaseId,
            item.groupId,
            props.phase.id,
            props.phase.groups[0].id,
            null,
            item,
            null
          )
        }

        props.onDropItem()
      } else {
        // Revert to original position, if pagebreak not placed in between items
        props.onMoveItem(
          item.phaseId,
          item.groupId,
          item.orgPhaseId,
          item.orgGroupId,
          null,
          item,
          item.orgIndex
        )
      }
    }
  }
}

@dropTarget((_props) => 'all', phaseTarget, (connect, monitor) => ({
  connectDropTarget: connect.dropTarget(),
  isOver: monitor.isOver(),
  canDrop: monitor.canDrop()
}))
class InvoicePhase extends InvoicePhaseBase {
  render () {
    const { connectDropTarget } = this.props
    return connectDropTarget(super.render())
  }
}

export default InvoicePhase
